import { useEffect, useRef, useState } from "react";

export const useAutoPageSize = (min = 6) => {
  const containerRef = useRef<HTMLUListElement>(null);
  const itemRef = useRef<HTMLLIElement>(null);
  const [pageSize, setPageSize] = useState(min);

  const calculate = () => {
    if (!containerRef.current || !itemRef.current) return;

    const containerHeight = containerRef.current.getBoundingClientRect().height;
    const itemHeight = itemRef.current.getBoundingClientRect().height;

    if (itemHeight > 0 && containerHeight > 0) {
      let result = Math.floor(containerHeight / itemHeight);

      result = Math.max(min, result - 1);

      setPageSize(result);
    }
  };

  useEffect(() => {
    calculate();

    const t = setTimeout(calculate, 150);
    window.addEventListener("resize", calculate);

    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", calculate);
    };
  }, []);

  return { containerRef, itemRef, pageSize };
};
